<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered" v-if="process !== 'next_actions'">
			<div class="portlet-title">
				<div class="caption">
					Manage Locations for <b>{{ editingRegion.name }}</b>
				</div>
			</div>
			<div class="portlet-body portlet-overflow">
				<div class="margin-top-20 row search-content-4">
					<div class="search-table table-responsive">
						<table class="table table-striped table-condensed">
							<thead>
								<tr>
									<th><a class="no-click font-grey-mint">Location Name</a></th>
									<th><a class="no-click font-grey-mint">Actions</a></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="location in editingRegion.locations">
									<td><h4>{{ location.name }}</h4></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Region from '../../../../controllers/Region'
import { mapGetters } from 'vuex'

/**
 * Manage Locations module is a page for viewing the locations in a region.
 * @class ManageLocations
 * @extends Region
 * @since 0.0.8
 */

export default {
	name: 'manage-locations',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			editingRegion: {
				locations: []
			},
			regionId: 0
		}
	},
	/**
	 * Run on `created` to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof ManageLocations
	 * @version 0.0.8
	 */
	created () {
		if (this.$route.name === 'My Business Regions - Manage Locations') {
			this.activePanel = true

			if (this.$route.params.region_id && this.$route.params.region_id !== 'undefined' && parseInt(this.$route.params.region_id) !== 0) {
				this.regionId = this.$route.params.region_id
				this.getRegionLocations()
			} else {
				this.closePanel()
			}
		}
	},
	computed: mapGetters([
		'activeBusinessId'
	]),
	methods: {
		/**
		 * To pull in the list of locations that are in the current region
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof ManageLocations
		 * @version 0.0.8
		 */
		getRegionLocations () {
			let _this = this
			return Region.getRegionLocations(this.activeBusinessId, this.regionId).then(response => {
				_this.editingRegion.locations = response.payload.locations
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To close the manage locations panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof ManageLocations
		 * @version 0.0.8
		 */
		closePanel () {
			this.$router.push('app/my_business/regions')
		}
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof ManageLocations
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name === 'My Business Regions - Manage Locations') {
				this.activePanel = true
				this.process = 'step_1'
				if (this.$route.params.region_id && this.$route.params.region_id !== 'undefined' && parseInt(this.$route.params.region_id) !== 0) {
					this.regionId = this.$route.params.region_id
					this.getRegionLocations()
				} else {
					this.closePanel()
				}
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// ManageLocations.vue?1818f7b4